import { Texture } from "@pixi/core";
import { Container } from "@pixi/display";
import { Sprite } from "@pixi/sprite";
import { Graphics } from "pixi.js";
import { DynamicResourcesPackage } from "../../../../../../resources/DynamicResourcesPackage";

const WHITE_BACKGROUND_OFFSET: number = 2;
const DEFAULT_AVATAR_SIZE: number = 54;

export class NftPin extends Container {
    private nft: Sprite;

    public constructor() {
        super();
        this.nft = new Sprite(Texture.WHITE);
        this.nft.width = this.nft.height = DEFAULT_AVATAR_SIZE;
        const nftRadius = DEFAULT_AVATAR_SIZE * 0.5;
        const nftMask = new Graphics();
        nftMask.beginFill(0xffffff);
        nftMask.drawCircle(nftRadius, nftRadius, nftRadius);
        nftMask.endFill();
        this.nft.mask = nftMask;
        const whiteBackground = new Graphics();
        whiteBackground.beginFill(0xffffff);
        whiteBackground.drawCircle(nftRadius, nftRadius, nftRadius + WHITE_BACKGROUND_OFFSET);
        whiteBackground.endFill();
        this.addChild(whiteBackground, this.nft, nftMask);
    }

    public async updateNftTexture(textureUrl: string): Promise<void> {
        const texture = await this.loadBuildingTexture(textureUrl);
        this.nft.texture = texture;
    }

    private async loadBuildingTexture(textureUrl: string): Promise<Texture> {
        const cardDynamicResources = new DynamicResourcesPackage();
        cardDynamicResources.add(textureUrl);
        await cardDynamicResources.load();
        return cardDynamicResources.resource(textureUrl);
    }
}
